import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Conserva query string al redirigir rutas viejas.
 * `setParams` fuerza claves en el destino (p. ej. tab=methods en Finanzas).
 *
 * Preferible montar estas rutas **fuera** de `MainShell` / `GlobalPeriodProvider`
 * para que el chip de periodo no reescriba la URL legacy antes del redirect.
 */
export function PreserveSearchRedirect({
  to,
  setParams,
}: {
  to: string;
  setParams?: Record<string, string>;
}) {
  const [params] = useSearchParams();
  const [base, existing] = to.split('?');
  const next = new URLSearchParams(params);

  if (existing) {
    new URLSearchParams(existing).forEach((value, key) => {
      if (!next.has(key)) next.set(key, value);
    });
  }
  if (setParams) {
    for (const [key, value] of Object.entries(setParams)) {
      next.set(key, value);
    }
  }

  const qs = next.toString();
  return <Navigate to={{ pathname: base, search: qs ? `?${qs}` : '' }} replace />;
}
